import React from 'react'
import { FormattedMessage } from 'react-intl'

// JSX for a general error
export function GeneralError() {
  return (
    <>
      <FormattedMessage id="GENERAL.ERROR" />
      <a href="https://support.augmentt.com" target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="GENERAL.CONTACT_SUPPORT" />
      </a>
    </>
  )
}
